import type { Theme } from '../../types/theme';

export const sentryTheme: Theme = {
  id: 'sentry',
  name: 'Sentry',
  description: 'Dark dashboard with data-dense layout for error monitoring',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/sentry/DESIGN.md',
  visualKeywords: ['dark', 'pink-purple accent', 'data-dense', 'error monitoring', 'dashboard'],
  colors: {
    background: '#0d0d0d',
    surface: '#1a1a1a',
    surfaceElevated: '#242424',
    textPrimary: '#ffffff',
    textSecondary: '#9090a0',
    textMuted: '#9090a0',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#fa25a4',
    primaryHover: '#e61190',
    primaryActive: '#dc0786',
    accent: '#fa25a4',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'technical',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
